// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,p,h4,li{font-size:14px}h3{margin-top:0;font-size:16px}.MuiFormLabel-asterisk{color:red}", ""]);
// Exports
module.exports = exports;
